<template>
    <z-action-picker
      v-model="showModal"
      title="请选择您与对方的私信"
      height="80vh"
      subTitle="(最多10条)"
      @confirm="onConfirm"
      :btn-props="btnProps"
    >
      <div class="slot">
        <z-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          v-if="!showStance"
        >
        <z-checkbox-group v-model="checkboxresult" :max="10" @exceed="onExceed">
          <div class="checkbox-wrap">
            <z-checkbox
              v-for="(item,index) in letterList"
              :key="index"
              :name="item.msgId">
              <LetterItem :item="item"></LetterItem>
            </z-checkbox>
          </div>
        </z-checkbox-group>
        </z-list>
        <z-stance v-if="showStance" :show-btn="false" :show-info="false" descText="没有私信记录哦～" type="message"></z-stance>
      </div>
    </z-action-picker>
</template>

<script>
import LetterItem from './LetterItem'
import { List, ActionPicker, Checkbox, CheckboxGroup, Stance } from '@zz-common/zz-ui';
import { getonlinemsg, getuserpic } from '@api/resourceApi'
import { getCookie } from '@lib/utils'

const DEFAULT_PAGE_SIZE = 15

export default {
  name: 'LetterList',
  components: {
    'z-list': List,
    'z-action-picker': ActionPicker,
    'z-checkbox': Checkbox,
    'z-checkbox-group': CheckboxGroup,
    'z-stance': Stance,
    LetterItem
  },
  props: ['show'],
  inject: ['sharedData'],
  data() {
    return {
      letterList: [],
      loading: false,
      finished: false,
      checkboxresult: [],
      timeStamp: '1565162000',
      objectPic: {}
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(_val) {
        this.$emit('close')
      }
    },
    showStance() {
      return this.finished && this.letterList.length == 0
    },
    btnProps() {
      if (this.checkboxresult.length > 0) return {}
      return {
        disabled: true
      }
    }
  },
  async mounted() {
    await this.getuserpic()
  },
  methods: {
    onLoad() {
      this.getLetterInfo()
    },
    onExceed() {
      this.$toast('最多只能选择10个');
    },
    getuserpic() {
      return getuserpic({
        uid: getCookie('uid'),
        toUid: this.sharedData.toUid
      })
        .then((res) => {
          this.objectPic = res.reduce((prev, cur) => {
            Object.entries(cur).forEach(([key, value]) => {
              prev[key] = value
            })
            return prev
          }, {})
          console.log('看看头像结构', this.objectPic)
        })
        .catch((err) => {
          console.error('---login--error', err)
        })
    },
    getLetterInfo() {
      return getonlinemsg({
        uid: getCookie('uid'),
        contact_uid: this.sharedData.toUid,
        user_type: 'n',
        source: '21',
        msg_count: DEFAULT_PAGE_SIZE,
        start_timestamp: this.timeStamp
      })
        .then((res) => {
          this.loading = false
          console.log('-----letterInfo--', res)
          const msgData = res.protocol_content?.msg_data || []
          if (msgData.length == 0) {
            this.finished = true
            return
          }
          this.handleLetterData(msgData)
        })
        .catch((err) => {
          this.loading = false
          this.finished = true
          console.error(err)
        })
    },
    onConfirm() {
      const data = this.letterList.filter((item) => {
        return this.checkboxresult.includes(item.msgId)
      })
      this.$emit('select', data)
      this.$emit('close')
    },
    handleLetterData(list) {
      list.forEach((item) => {
        const portrait = this.objectPic[item.from_uid]
        if (item.msg_content.text !== '') {
          this.letterList.push({
            timeStamp: item.timestamp,
            clientMsgId: item.client_msg_id,
            msgId: item.msg_id,
            userId: item.from_uid,
            type: '1',
            isMe: item.from_uid == getCookie('uid'),
            portrait,
            content: item.msg_content.text
          })
        } else {
          const { capimg = '' } = item.msg_content
          const { url = '' } = capimg
          if (capimg && url !== '') {
            this.letterList.push({
              timeStamp: item.timestamp,
              clientMsgId: item.client_msg_id,
              msgId: item.msg_id,
              userId: item.from_uid,
              type: '2',
              isMe: item.from_uid == getCookie('uid'),
              portrait,
              content: url.indexOf('http') > -1 ? url : 'https://' + url
            })
          }
        }
      })
      if (list.length > 0) this.timeStamp = list[list.length - 1].timestamp
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>